/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, getter-return, warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import moment from 'moment';

export default class TermsService extends Service {
  // Services
  @service
  session;

  @service
  store;

  @tracked
  hasData = false;
  @tracked
  terms = [];

  _betweenTermCalc(reportDate) {
    let now = moment(reportDate);
    return this.terms.find((term) => {
      return (
        now.isAfter(moment(term.get('end')), 'day') &&
        (isEmpty(term.next) ||
          now.isBefore(moment(term.next.get('start')), 'day'))
      );
    });
  }

  currentTermAtDate(reportDate) {
    let currentTerm = this.terms.find((term) => {
      return term.isCurrentAtDate(reportDate);
    });
    if (isEmpty(currentTerm)) {
      // We're in between terms
      currentTerm = this._betweenTermCalc(reportDate);
    }
    return currentTerm;
  }

  @computed('terms.@each.isCurrent')
  get currentTerm() {
    let currentTerm = this.terms.find((term) => term.isCurrent);
    if (isEmpty(currentTerm)) {
      // We're in between terms
      currentTerm = this._betweenTermCalc();
    }
    return currentTerm;
  }

  @computed('terms.@each.academicYear', 'currentTerm.academicYear')
  get currentAcademicYearTerms() {
    if (isEmpty(this.currentTerm)) {
      return;
    }
    return this.terms.filter(
      (term) => term.academicYear === this.currentTerm.academicYear,
    );
  }

  init() {
    super.init(...arguments);
    let schoolId = this.get('session.school');
    this.store.query('term', { schoolId }).then((terms) => {
      this.terms = terms;
      this.hasData = true;
    });
  }

  refresh() {
    if (this.hasData) {
      this.terms.update();
    }
  }
}
